// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer-footerBox-CunTJ {
  background: var(--footer-bg);
  color: var(--common-tertiary-white-foreground);
}
.Footer-bottomSpace-_SRrC .Footer-footerInner-bZCdP {
  padding-bottom: 96px;
}
.Footer-footerInner-bZCdP {
  max-width: 1200px;
  margin: 0 auto;
  padding: 64px 24px 28px;
}
/* ---- Top: brand + link columns ---- */
.Footer-footerTop-ggCN0 {
  display: grid;
  grid-template-columns: 1.7fr repeat(5, 1fr);
  gap: 40px 28px;
  padding-bottom: 44px;
  border-bottom: 1px solid var(--secondary-border);
}
.Footer-brandCol-gS8Ay {
  max-width: 300px;
}
.Footer-brand-toZ2E {
  display: inline-block;
  font-size: 24px;
  font-weight: 800;
  color: var(--common-primary-white-foreground);
  text-decoration: none;
  letter-spacing: -0.01em;
}
.Footer-brandTag-xhQno {
  font-size: 14px;
  line-height: 1.6;
  color: var(--common-tertiary-white-foreground);
  margin: 12px 0 18px;
}
.Footer-appLinks-kMqwW {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 10px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  margin-bottom: 18px;
}
.Footer-appLink-iAq7_ {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  font-size: 13px;
  font-weight: 700;
  color: var(--common-primary-white-foreground);
  text-decoration: none;
  border: 1px solid var(--secondary-border);
  border-radius: 10px;
  padding: 8px 14px;
  -webkit-transition: border-color 0.15s, color 0.15s;
  transition: border-color 0.15s, color 0.15s;
}
.Footer-appLink-iAq7_:hover {
  border-color: var(--common-primary-white-foreground);
}
.Footer-socialRow-efk_2 {
  list-style: none;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 16px;
  margin: 0;
  padding: 0;
}
.Footer-socialRow-efk_2 img {
  width: 20px;
  height: 20px;
}
.Footer-linkCol-UOIGJ h3.Footer-colTitle-jg1sY,
.Footer-colTitle-jg1sY {
  font-size: 14px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--common-primary-white-foreground);
  margin: 0 0 16px;
}
.Footer-linkCol-UOIGJ ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.Footer-linkCol-UOIGJ li {
  margin-bottom: 11px;
}
.Footer-footerLink-ikduO {
  font-size: 14px;
  line-height: 1.4;
  color: var(--common-tertiary-white-foreground);
  text-decoration: none;
  -webkit-transition: color 0.15s;
  transition: color 0.15s;
}
.Footer-footerLink-ikduO:hover,
.Footer-footerLink-ikduO:focus {
  color: var(--common-primary-white-foreground);
  text-decoration: none;
}
/* ---- SEO internal-linking band (sitewide -> priority metro service pages) ---- */
.Footer-seoBand-sg1Qh {
  padding: 40px 0 10px;
  border-bottom: 1px solid var(--secondary-border);
}
.Footer-seoTitle-zQaYt {
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--common-tertiary-white-foreground);
  margin: 0 0 22px;
}
.Footer-seoGrid-vcWh6 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px 28px;
}
/* ---- Bottom: payments + Stripe + copyright ---- */
.Footer-footerBottom-q7v53 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  gap: 18px;
  padding-top: 24px;
}
.Footer-payments-nVuf7 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 10px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}
.Footer-paymentCardIcon-eD0o6 {
  width: 34px;
  height: 23px;
  -o-object-fit: contain;
     object-fit: contain;
  background: #fff;
  border-radius: 4px;
  padding: 1px 3px;
}
.Footer-poweredByStripe-m2MVS {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 6px;
  margin-left: 8px;
  font-size: 13px;
  text-decoration: none;
  color: var(--common-tertiary-white-foreground);
  -webkit-transition: opacity 0.15s;
  transition: opacity 0.15s;
}
.Footer-poweredByStripe-m2MVS:hover {
  opacity: 0.85;
}
.Footer-pbsBrand-J6YSf {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 4px;
  font-weight: 700;
  color: #635bff;
}
.Footer-pbsMark-PZa4D {
  width: 15px;
  height: 16px;
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
}
.Footer-copyRight-QMINp {
  font-size: 13px;
  color: var(--common-tertiary-white-foreground);
}
@media (max-width: 980px) {
  .Footer-footerTop-ggCN0 {
    grid-template-columns: 1fr 1fr 1fr;
  }
  .Footer-brandCol-gS8Ay {
    grid-column: 1 / -1;
    max-width: 420px;
  }
}
@media (max-width: 600px) {
  .Footer-footerInner-bZCdP {
    padding: 44px 20px 24px;
  }
  .Footer-footerTop-ggCN0 {
    grid-template-columns: 1fr 1fr;
    gap: 30px 20px;
  }
  .Footer-seoGrid-vcWh6 {
    grid-template-columns: 1fr;
    gap: 26px;
  }
  .Footer-footerBottom-q7v53 {
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,8CAA8C;AAChD;AACA;EACE,oBAAoB;AACtB;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,2CAA2C;EAC3C,cAAc;EACd,oBAAoB;EACpB,gDAAgD;AAClD;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,6CAA6C;EAC7C,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,8CAA8C;EAC9C,mBAAmB;AACrB;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,SAAS;EACT,mBAAe;MAAf,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,6CAA6C;EAC7C,qBAAqB;EACrB,yCAAyC;EACzC,mBAAmB;EACnB,iBAAiB;EACjB,mDAA2C;EAA3C,2CAA2C;AAC7C;AACA;EACE,oDAAoD;AACtD;AACA;EACE,gBAAgB;EAChB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,SAAS;EACT,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;AACd;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,6CAA6C;EAC7C,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,8CAA8C;EAC9C,qBAAqB;EACrB,+BAAuB;EAAvB,uBAAuB;AACzB;AACA;;EAEE,6CAA6C;EAC7C,qBAAqB;AACvB;AAEA,mFAAmF;AACnF;EACE,oBAAoB;EACpB,gDAAgD;AAClD;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,8CAA8C;EAC9C,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;AAChB;AAEA,oDAAoD;AACpD;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,mBAAe;MAAf,eAAe;EACf,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,mBAAe;MAAf,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,sBAAmB;KAAnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,8CAA8C;EAC9C,iCAAyB;EAAzB,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAc;MAAd,kBAAc;UAAd,cAAc;AAChB;AACA;EACE,eAAe;EACf,8CAA8C;AAChD;AAEA;EACE;IACE,kCAAkC;EACpC;EACA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,8BAA8B;IAC9B,cAAc;EAChB;EACA;IACE,0BAA0B;IAC1B,SAAS;EACX;EACA;IACE,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,kBAAkB;EACpB;AACF","sourcesContent":[".footerBox {\n  background: var(--footer-bg);\n  color: var(--common-tertiary-white-foreground);\n}\n.bottomSpace .footerInner {\n  padding-bottom: 96px;\n}\n\n.footerInner {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 64px 24px 28px;\n}\n\n/* ---- Top: brand + link columns ---- */\n.footerTop {\n  display: grid;\n  grid-template-columns: 1.7fr repeat(5, 1fr);\n  gap: 40px 28px;\n  padding-bottom: 44px;\n  border-bottom: 1px solid var(--secondary-border);\n}\n\n.brandCol {\n  max-width: 300px;\n}\n.brand {\n  display: inline-block;\n  font-size: 24px;\n  font-weight: 800;\n  color: var(--common-primary-white-foreground);\n  text-decoration: none;\n  letter-spacing: -0.01em;\n}\n.brandTag {\n  font-size: 14px;\n  line-height: 1.6;\n  color: var(--common-tertiary-white-foreground);\n  margin: 12px 0 18px;\n}\n.appLinks {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-bottom: 18px;\n}\n.appLink {\n  display: inline-flex;\n  align-items: center;\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--common-primary-white-foreground);\n  text-decoration: none;\n  border: 1px solid var(--secondary-border);\n  border-radius: 10px;\n  padding: 8px 14px;\n  transition: border-color 0.15s, color 0.15s;\n}\n.appLink:hover {\n  border-color: var(--common-primary-white-foreground);\n}\n.socialRow {\n  list-style: none;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin: 0;\n  padding: 0;\n}\n.socialRow img {\n  width: 20px;\n  height: 20px;\n}\n\n.linkCol h3.colTitle,\n.colTitle {\n  font-size: 14px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--common-primary-white-foreground);\n  margin: 0 0 16px;\n}\n.linkCol ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.linkCol li {\n  margin-bottom: 11px;\n}\n.footerLink {\n  font-size: 14px;\n  line-height: 1.4;\n  color: var(--common-tertiary-white-foreground);\n  text-decoration: none;\n  transition: color 0.15s;\n}\n.footerLink:hover,\n.footerLink:focus {\n  color: var(--common-primary-white-foreground);\n  text-decoration: none;\n}\n\n/* ---- SEO internal-linking band (sitewide -> priority metro service pages) ---- */\n.seoBand {\n  padding: 40px 0 10px;\n  border-bottom: 1px solid var(--secondary-border);\n}\n.seoTitle {\n  font-size: 13px;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--common-tertiary-white-foreground);\n  margin: 0 0 22px;\n}\n.seoGrid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 32px 28px;\n}\n\n/* ---- Bottom: payments + Stripe + copyright ---- */\n.footerBottom {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 18px;\n  padding-top: 24px;\n}\n.payments {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n.paymentCardIcon {\n  width: 34px;\n  height: 23px;\n  object-fit: contain;\n  background: #fff;\n  border-radius: 4px;\n  padding: 1px 3px;\n}\n.poweredByStripe {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-left: 8px;\n  font-size: 13px;\n  text-decoration: none;\n  color: var(--common-tertiary-white-foreground);\n  transition: opacity 0.15s;\n}\n.poweredByStripe:hover {\n  opacity: 0.85;\n}\n.pbsBrand {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-weight: 700;\n  color: #635bff;\n}\n.pbsMark {\n  width: 15px;\n  height: 16px;\n  flex: 0 0 auto;\n}\n.copyRight {\n  font-size: 13px;\n  color: var(--common-tertiary-white-foreground);\n}\n\n@media (max-width: 980px) {\n  .footerTop {\n    grid-template-columns: 1fr 1fr 1fr;\n  }\n  .brandCol {\n    grid-column: 1 / -1;\n    max-width: 420px;\n  }\n}\n@media (max-width: 600px) {\n  .footerInner {\n    padding: 44px 20px 24px;\n  }\n  .footerTop {\n    grid-template-columns: 1fr 1fr;\n    gap: 30px 20px;\n  }\n  .seoGrid {\n    grid-template-columns: 1fr;\n    gap: 26px;\n  }\n  .footerBottom {\n    justify-content: center;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footerBox": `Footer-footerBox-CunTJ`,
	"bottomSpace": `Footer-bottomSpace-_SRrC`,
	"footerInner": `Footer-footerInner-bZCdP`,
	"footerTop": `Footer-footerTop-ggCN0`,
	"brandCol": `Footer-brandCol-gS8Ay`,
	"brand": `Footer-brand-toZ2E`,
	"brandTag": `Footer-brandTag-xhQno`,
	"appLinks": `Footer-appLinks-kMqwW`,
	"appLink": `Footer-appLink-iAq7_`,
	"socialRow": `Footer-socialRow-efk_2`,
	"linkCol": `Footer-linkCol-UOIGJ`,
	"colTitle": `Footer-colTitle-jg1sY`,
	"footerLink": `Footer-footerLink-ikduO`,
	"seoBand": `Footer-seoBand-sg1Qh`,
	"seoTitle": `Footer-seoTitle-zQaYt`,
	"seoGrid": `Footer-seoGrid-vcWh6`,
	"footerBottom": `Footer-footerBottom-q7v53`,
	"payments": `Footer-payments-nVuf7`,
	"paymentCardIcon": `Footer-paymentCardIcon-eD0o6`,
	"poweredByStripe": `Footer-poweredByStripe-m2MVS`,
	"pbsBrand": `Footer-pbsBrand-J6YSf`,
	"pbsMark": `Footer-pbsMark-PZa4D`,
	"copyRight": `Footer-copyRight-QMINp`
};
module.exports = ___CSS_LOADER_EXPORT___;
